import { GET_PAYMENTVENDOR_LIST } from "../actions/types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_PAYMENTVENDOR_LIST:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/paymentvendorsList.js